import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CaseFormSectionContainerComponent } from '../case-form-section-container/case-form-section-container.component';
import { RichTextEditorComponent } from '../fields/rich-text-editor/rich-text-editor.component';
import { HelpPageService } from 'app/help/help-page.service';
import { Subject, takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-need-help-form',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, FormsModule, CaseFormSectionContainerComponent, RichTextEditorComponent, TranslateModule],
  templateUrl: './need-help-form.component.html',
  styleUrl: './need-help-form.component.scss'
})
export class NeedHelpFormComponent implements OnDestroy {
  @Input() form!: FormGroup;
  @Input() isAdmin: boolean = false;

  isEditable: { [key: string]: boolean } = {
    needHelpContent: false,
    newCustomerSiteContent: false,
  };

  private formBackup: { [key: string]: any } = {};
  private destroy$ = new Subject<void>();
  errorMessage: string | null = null;

  constructor(private helpPageService: HelpPageService) {}

  ngOnChanges(): void {
    if (this.form) {
      if (!this.isAdmin) {
        Object.keys(this.isEditable).forEach((field) => {
          this.form.get(field)?.disable();
        });
      }
    }
    this.loadHelpContent();
  }

  loadHelpContent(): void {
    this.helpPageService.getHelpData('GeneralHelpData')
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.form.get('needHelpContent')?.setValue(data.content);
          this.form.get('needHelpContent')?.disable();
          this.errorMessage = null;
        },
      );

    this.helpPageService.getHelpData('CustomerSiteAddingHelpData')
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.form.get('newCustomerSiteContent')?.setValue(data.content);
          this.form.get('newCustomerSiteContent')?.disable();
          this.errorMessage = null;
        },
      );
  }

  toggleEditing(field: string): void {
    if (!this.isEditable[field]) {
      this.isEditable[field] = true;
      this.formBackup[field] = this.form.get(field)?.value;
      this.form.get(field)?.enable();
    }
  }

  saveChanges(field: string): void {
    const type = field === 'needHelpContent' ? 'GeneralHelpData' : 'CustomerSiteAddingHelpData';
    const content = this.form.get(field)?.value;

    this.helpPageService.addHelpData(type, content)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => {
          this.isEditable[field] = false;
          this.form.get(field)?.disable();
          this.errorMessage = null;
        },
      );
  }

  cancelChanges(field: string): void {
    this.isEditable[field] = false;
    this.form.get(field)?.setValue(this.formBackup[field]);
    this.formBackup[field] = null;
    this.form.get(field)?.disable();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
